import { useEffect, useState } from "react";

/* -------- packages -------- */
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { fetchGroupsRequest, fetchCommentsRequest, fetchUsersRequest, deleteGroupRequest, openEditGroupPage, clearGroupSuccess, clearGroupErrors } from "../../store/actions";
import { setUserBan } from "../../helpers/backend_helper";
/* -------- ------- -------- */

/* -------- components -------- */
import TableContainer from "../../components/ui/List/TableContainer";
import Breadcrumb from "../../components/ui/Breadcrumbs";
import Loading from "../../components/ui/Loading";
import ErrorHandler from "../../components/ui/Error/ErrorHandler";
/* -------- ------- -------- */

const Groups = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { users } = useSelector(state => state.Users);
  const parameters = useSelector(state => state.Parameters);
  const { groups, errorGroup, groupAdded } = useSelector(state => state.Groups);
  const [groupsFormatted, setGroupsFormatted] = useState([]);

  document.title = `${t('groups')} | ${parameters.appName}`; //meta title
  
  useEffect(() => {
    dispatch(fetchGroupsRequest());
    dispatch(fetchCommentsRequest())
    
    if(!users.length) {
      dispatch(fetchUsersRequest());
    }
  }, [dispatch]);


  useEffect(() => {
    if (groups) {
      let newGroups = groups.map((group) => {
        return {
          id: group.id,
          label: group.lib
        }
      });
      setGroupsFormatted(newGroups);
    }
  }, [groups]);

  // Configuration des colonnes
  const columnConfig = [
    { key: 'id', type: 'text' },
    { key: 'lib', type: 'text'},
    { key: 'ProjComments', type: 'iconTabComments' },
    { key: 'ProjDocuments', type: 'iconTabDocuments' },
    { key: 'createdAt', type: 'date' },
    { key: 'updatedAt', type: 'date' },
  ];

  // Configuration des filtres
  const filterConfig = [
  ];

  ErrorHandler(errorGroup, clearGroupErrors);

  useEffect(() => {
    if (groupAdded) {
      toast.success(t('dataSaved'));
      dispatch(clearGroupSuccess());
    }
  }, [groupAdded]);

  return (

      <div className="page-content">
        <Container fluid>
          <Breadcrumb breadcrumbItem={t("group")}/>

          {(groups) ?
          (
            <TableContainer
            columnConfig={columnConfig}
            filterConfig={filterConfig}
            data={groups}
            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            theadClass="table-light"
            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            pagination="pagination"
            divClassName="table-responsive"
            isBordered={true}
            isPagination={true}
            isGlobalFilter={true}
            buttonClass="btn btn-primary btn-rounded waves-effect waves-light addContact-modal mb-2"
            buttonName="group"
            prefListName="group"
            totalKpi={{label: 'numberOfGroups'}}
            isAddButton={true}
            linkToNew={'/groups/new'}
            editFunction={openEditGroupPage} 
            deleteFunction={deleteGroupRequest}
            linkedEntityModel={'ProjGroup'}
            defaultSortColumn={'lib'}
            defaultSortDirection={'asc'}
          />

          ) : (
          <Loading type={"page"} />
        )
          }
        </Container>
        <ToastContainer />
      </div>

  );
};

export default Groups;
